import { orderBy } from 'lodash'
//更新ppi
async function refreshBox(_this, url, params) {
	return _this.$post(url, params).then(res => {
		return res
	})
}
// 新增
async function newRectToBox(_this, info) {
	let appendInfo = JSON.parse(info.rectItem.appendInfo)
	let box = appendInfo.box ?? []
	let h = 30,
		w = 50
	if (box.length > 0) {
		h = box[0].h
		w = box[0].w
	}
	let remarks = JSON.parse(info.rectItem.remarks)
	const insertBox = {
		m: '',
		n: '',
		c: -1,
		r: -1,
		v: info.value || '',
		h: h,
		w: w,
		x: info.left,
		y: info.top
	}
	box.push(insertBox)
	if (info.tempSelLikeSubOrObjVal?.length > 0) {
		let rectIndexBox = []
		info.tempSelLikeSubOrObjVal.forEach(resp => {
			resp.items.forEach(responce => {
				rectIndexBox.push(Number(responce.pkId))
			})
		})
		rectIndexBox = Array.from(new Set(rectIndexBox)).sort()
		if (box.length === rectIndexBox.length) {
			box.forEach((res, index) => {
				res.v = rectIndexBox[index]
				res.n = rectIndexBox[index]
			})
		}
	}
	appendInfo.box = box
	remarks.align = info.direction
	remarks.isDone = false
	delete appendInfo.boxFromAppendInfo
	info.rectItem.appendInfo = JSON.stringify(appendInfo)
	info.rectItem.remarks = JSON.stringify(remarks)
	const params = {
		subjectId: info.subjectId,
		examId: info.examId,
		versionId: info.versionId,
		ppiId: info.rectItem['pkId'],
		ppiStr: JSON.stringify(info.rectItem)
	}
	return refreshBox(_this, 'Cv/refreshPpi', params).then(res => {
		return res
	})
}
// 识别 选做题 类 选择题
async function handleRecogniseChoose(box, rect) {
	let rectIndexBox = []
	rect.forEach(resp => {
		resp.items.forEach(responce => {
			rectIndexBox.push(responce)
		})
	})
	let resultRect = Array.from(new Set(rectIndexBox)).sort()
	let resultBox = orderBy(box, ['x'], ['asc'])
	resultBox.forEach((res, index) => {
		res.v = resultRect[index].pkId
		res.n = resultRect[index].pkId
		res.smallTopic = resultRect[index].smallTopic
	})
	return resultBox
}
export { refreshBox, newRectToBox, handleRecogniseChoose }
